export const getCentralKitchenStores = (stores) => stores.filter(({ isKitchen }) => isKitchen);

export const getSalesPointStores = (stores) => stores.filter(({ isKitchen }) => !isKitchen);
